/**
 * 七牛云
 */
import http from '../../api/http'
const state = {
    uploadUrl: 'http://upload.qiniu.com/',
    options: {
        disable_statistics_report: false,
        runtimes: 'html5,flash,html4',
        browse_button: '',
        filters: {},
        max_file_size: '5mb',
        flash_swf_url: 'content/js/Moxie.swf',
        uptoken_url: '/qiniu/upToken',
        domain: 'http://webchecker-dev.51yxwz.com/',
        get_new_uptoken: false,
        auto_start: true,
        init: {
            // 文件添加进队列后，处理相关的事情
            'FilesAdded': (up, files) => {},
            // 每个文件上传前，处理相关的事情
            'BeforeUpload': (up, file) => {},
            // 每个文件上传时，处理相关的事情
            'UploadProgress': (up, file) => {},
            //队列文件处理完毕后，处理相关的事情
            'UploadComplete': () => {},
            // 每个文件上传成功后，处理相关的事情
            'FileUploaded': (up, file, info) => {},
            //上传出错时，处理相关的事情
            'Error': (up, err, errTip) => {},
            // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
            // 该配置必须要在unique_names: false，save_key: false时才生效
            'Key': (up, file) => {}
        }
    },
    imageParam: '?imageView2/1/w/${width}/h/${height}/format/jpg/q/75|imageslim'
};

const getters = {
    getBucketUrl: state => state.options.domain,
    getOptions: (state) => (options) => {
        return Object.assign(state.options, options);
    },
    getFileUrl: (state, getters) => url => {
        return getters.getBucketUrl + url;
    },
    getImageUrl: (state, getters) => (url, width, height) => {
        let imageParam = '';
        if (width) {
            height = height || width;
            imageParam = state.imageParam.replace('${width}', width).replace('${height}', height);
        }
        return getters.getBucketUrl + url + imageParam;
    },
    getUserIcon: (state, getters) => (url, width, height) => {
        if (!url) {
            return '';
        } else if (/https?:\/\//i.test(url) || /^data:image\/\w+;base64,/i.test(url)) {
            return url;
        } else {
            return getters.getImageUrl(url, width, height);
        }
    }
};

const mutations = {

};

const actions = {
    getUpToken({state}) {
        return http.httpGet(state.options.uptoken_url, null, true).then(res => res.data);
    },
    uploadFile({state}, formData) {
        return http.httpPost(state.uploadUrl, formData, true);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/qiniu.js